let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hObPz")).then(() => parcelRequire('1G0jG'));